import { DeliveryMode, OrderMethod } from '../../../../../../../services/exports/Constants';

export default {
  title: "L'ordine richiederà più/meno tempo?",
  text: {
    [OrderMethod.Pickup]:
      "Il cliente si aspetta l'ordine pronto per il ritiro il <strong>{{date}}</strong> alle <strong>{{time}}</strong><br/> Se necessario, puoi modificare l'orario qui.",
    [OrderMethod.OnSite]:
      "Il cliente si aspetta l'ordine a <strong>{{table}}</strong><br/><strong>{{date}}</strong> alle <strong>{{time}}</strong><br/> Se necessario, puoi modificare l'orario qui.",
    // A table order whose table the backend could not name.
    on_site_without_table:
      "Il cliente si aspetta l'ordine al suo tavolo il <strong>{{date}}</strong> alle <strong>{{time}}</strong><br/> Se necessario, puoi modificare l'orario qui.",
    [OrderMethod.Delivery]: {
      [DeliveryMode.Internal]:
        "Il cliente si aspetta la consegna dell'ordine il <strong>{{date}}</strong> alle <strong>{{time}}</strong><br/> Se necessario, puoi modificare l'orario qui.",
      [DeliveryMode.External]:
        "L'autista arriverà a ritirare l'ordine alle <strong>{{time}}{{confidenceLabel}}</strong>",
    },
  },
  labels: {
    today: 'Oggi',
  },
  confidence_labels: {
    estimated: ' (stimato!)',
    confirmed: '',
  },
  buttons: {
    confirm_pickup: 'Conferma nuovo orario di ritiro',
    confirm_on_site: 'Conferma nuovo orario di servizio',
    confirm_delivery: 'Conferma nuovo orario di consegna',
  },
  confirmation_modal: {
    description: "Sei sicuro di voler cambiare l'orario da {{currentPickupTime}} a {{newPickupTime}}?",
    ok_button_text: 'Conferma nuovo orario',
    cancel_button_text: 'No, ripristina orario originale',
  },
};
